import { UrlUtil } from "@core/utils";
import { envConfig } from "@env/env-config";
import { DefaultCatalogUtil } from "@modules/catalog/default-catalog-util";
import { productCatalogWithPagePath } from "@modules/catalog/product-catalog/model/domain/ProductCatalog";


export class FooterPageController {

    public static $inject: Array<string> = ["$window", "pageContext", "$objectTree", "$q", "$translate"];

    public currentPage: string;
    public appPath: string;
    public emailAddress: string;

    public readonly rootPath: string;

    public qpmnDomain: string;

    private defaultCatalogUrl: string;

    private staticPageQpmnUrl: string;

    constructor(
        public $window: angular.IWindowService,
        public pageContext: qpmn.main.IPageContext,
        public $objectTree,
        public $q: angular.IQService,
        public $translate: angular.translate.ITranslateService,
    ) {
        this.rootPath = this.pageContext.rootPath;

        this.qpmnDomain = envConfig.getPath("", "");
    }

    /**
     * @description 获取当前页面
     */
    public getCurrentPage(): string {
        // TODO
        // let pathName = window.location.pathname;
        let patt = /\/(\w+).html|\/([a-zA-Z0-9-]+).html/;

        let matched = patt.exec(window.location.pathname);

        if (matched && matched.length > 0) {
            return matched[1] || matched[2];
        } else {
            return ""
        }
    }


    /**
     * @description 初始化
     */
    public $onInit() {
        /************** TODO  ************ */
        this.currentPage = this.getCurrentPage();
        this.appPath = envConfig.appPath();
        this.emailAddress = envConfig.supportEmail;

        //设置footer-page静态页面地址
        this.staticPageQpmnUrl = `${this.pageContext.rootPath}basic/footer-page-qpmn/index.html`;
        // let retCatalog = DefaultCatalogUtil.getDefaultCatalog(this.$objectTree, this.$q);
        // retCatalog.then((res) => {
        //     this.defaultCatalogUrl = UrlUtil.joinUrl([this.pageContext.rootPath, res.customizePath, (res.defaultCatalog as productCatalogWithPagePath).pagePath]);
        // }, (error) => {
        //     console.warn(error);
        // })
    }


    /**
     * @description 页面跳转
     * 
     * */
    // TODO 临时写法，待验证
    public jumpPage(url?: string) {
        let _url = url || "";
        this.$window.location.href = this.pageContext.rootPath + _url;
    }

}

